var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper"},[_c('canvas',{style:({ height: 'auto', width: '100%' }),attrs:{"id":"canvas","type":"2d"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }